import { render } from "./TermsAndConditionsAdmin.vue?vue&type=template&id=4a29dca0"
import script from "./TermsAndConditionsAdmin.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__